import getters from './getters';
import mutations from './mutations';
import payload from '~/config/sharedEnv';
export var state = () => ({
  payload
});
export default {
  namespaced: true,
  state,
  getters,
  mutations
};